import React from "react";
import { Button } from "./ui/button";
import { Phone, Calendar, ArrowRight } from "lucide-react";
import { businessInfo } from "../data/mock";

const CTASection = () => {
  return (
    <section className="py-16 bg-green-600 text-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          <div className="text-center lg:text-left">
            <h3 className="text-3xl md:text-4xl font-black tracking-tight">Ready for the fastest smog check in Marin?</h3>
            <p className="text-green-100 mt-2 text-lg">Walk-ins welcome. Book online or call — in and out in 20 minutes.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <Button asChild size="lg" className="bg-white text-green-600 hover:bg-slate-100 font-bold h-12 px-6">
              <a href={businessInfo.bookingUrl} target="_blank" rel="noreferrer">
                <Calendar className="w-5 h-5 mr-2" /> Book Now
                <ArrowRight className="w-4 h-4 ml-1" />
              </a>
            </Button>
            <Button asChild size="lg" variant="outline" className="bg-transparent border-white text-white hover:bg-white hover:text-green-600 font-bold h-12 px-6">
              <a href={`tel:${businessInfo.phoneRaw}`}>
                <Phone className="w-5 h-5 mr-2" /> {businessInfo.phone}
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
